import {
    PERFORM_LOGIN,
    PERFORM_LOGIN_SUCCESS,
    PERFORM_LOGIN_FAIL,
    PERFORM_INPUT_LOGIN,
    PERFORM_INPUT_PASSWORD,
    CLEAR_LOGIN_FORM
} from '../Actions/ActionsLogin'

export const ReducerLogin = (state = {
    login: '',
    password: '',
    error: null
}, action) => {
    switch (action.type) {
        case PERFORM_LOGIN:
            return {
                ...state
            }
        case PERFORM_LOGIN_SUCCESS:
            return {
                ...state
            }
        case PERFORM_LOGIN_FAIL:
            return {
                ...state,
                error: true
            }
        case CLEAR_LOGIN_FORM:
            return {
                ...state,
                error: false,
                login: '',
                password: ''
            }
        case PERFORM_INPUT_LOGIN:
            return {
                ...state,
                login: action.payload
            }
        case PERFORM_INPUT_PASSWORD:
            return {
                ...state,
                password: action.payload
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/ReducerLogin.js